import { ReactNode } from "react";
import { DateFormatter, TimeFormatter } from "@/utils/functions/helperFunctions";

type MobileLabelValueProps = {
    label: string;
    value?: ReactNode;
    id?: string;
    className?: string;
    valueClassName?: string;
};

export function MobileLabelValue({
    label,
    value,
    id,
    className,
    valueClassName,
}: MobileLabelValueProps) {
    return (
        <div className={["text-dark gs-mobile-field-row", className].filter(Boolean).join(" ")}>
            <span className="fw-bold gs-mobile-field-label">{label}</span>
            <span
                className={["gs-mobile-field-value", valueClassName].filter(Boolean).join(" ")}
                id={id}
            >
                {value}
            </span>
        </div>
    );
}

type MobileDateFieldProps = {
    label: string;
    value?: string | null;
    dateId?: string;
    timeId?: string;
    className?: string;
};

export function MobileDateField({ label, value, dateId, timeId, className }: MobileDateFieldProps) {
    return (
        <div className={["text-dark gs-mobile-date-field", className].filter(Boolean).join(" ")}>
            <span className="fw-bold gs-mobile-field-label">{label}</span>
            <div className="gs-mobile-date-values">
                <span className="gs-mobile-date-text" id={dateId}>
                    {DateFormatter(value ?? "")}
                </span>
                <span className="text-soft gs-mobile-time-text" id={timeId}>
                    {TimeFormatter(value ?? "")}
                </span>
            </div>
        </div>
    );
}
